/**
 * Registration MFA uses Okta Authn factor URLs. OTP challenge resend must POST to
 * …/factors/{id}/verify/resend. Enrollment can expose …/lifecycle/activate under `_links.resend`;
 * that URL must not be reused as the OTP resend target once a challenge `verify` link exists.
 */

export const isOktaFactorVerifyChallengeHref = (href: string | undefined): boolean => !!href && href.includes('/factors/') && /\/verify(?:\?|$)/.test(href)

/** Okta Authn: POST …/factors/{factorId}/verify/resend — avoid matching arbitrary URLs that only contain the substring `/verify/resend`. */
export const isOktaMfaVerifyResendHref = (href: string | undefined): boolean =>
  !!href && /\/factors\/[^/]+\/verify\/resend(?:[?#]|$)/.test(href)

/**
 * When building the proxy `/okta/authn/resend` body: drop a stale stored `resendLink` if it is
 * not a verify/resend URL while we have a challenge verify link (derive …/verify/resend instead).
 */
export const resolveOtpResendRequestHref = (resendLink: string | undefined, verifyLink: string | undefined): string | undefined => {
  if (resendLink && verifyLink && !isOktaMfaVerifyResendHref(resendLink) && isOktaFactorVerifyChallengeHref(verifyLink)) {
    return undefined
  }
  return resendLink
}

/**
 * Merge `_links.resend` into registration context without carrying enrollment `activate` resend
 * across a transition to MFA challenge when the response includes a verify link.
 */
export const mergeRegistrationMfaResendHref = (apiResend: string | undefined, apiVerify: string | undefined, prevResend: string | undefined): string | undefined => {
  if (apiResend && isOktaMfaVerifyResendHref(apiResend)) return apiResend
  if (apiResend?.includes('/lifecycle/activate')) {
    if (isOktaFactorVerifyChallengeHref(apiVerify)) return undefined
    return apiResend
  }
  if (apiResend) return apiResend
  if (isOktaFactorVerifyChallengeHref(apiVerify) && prevResend && !isOktaMfaVerifyResendHref(prevResend)) {
    return undefined
  }
  return prevResend
}
